<template>
  <div>
    <NuxtLayout
      name="asuostaticlayout"
      :title="$page?.studentsGraduation?.title"
      :image-source="$page?.studentsGraduation?.heroImage"
    >
      <!-- section intro -->
      <section class="px-space-xxs py-space-lg py-lg-space-xxl bg-light-2">
        <div class="container">
          <div class="row">
            <div
              class="col-12 col-lg-10 offset-lg-1 bg-white rds-lazy bg-pattern px-0"
              :data-background-image="$page?.studentsGraduation?.introBg"
            >
              <div class="pt-space-md pb-space-xxs py-lg-space-xl px-space-md px-lg-space-xl">
                <div class="row" tabindex="0">
                  <div class="col-12 col-lg-8 border-intro">
                    <div class="pe-lg-space-sm">
                      <!-- title -->

                      <h2 class="h2-medium pb-space-sm">
                        {{ $page?.studentsGraduation?.introTitle }}
                      </h2>
                      <div
                        class="mb-space-md"
                        v-html="$page?.studentsGraduation?.introDescription"
                      ></div>
                      <div class="mb-space-xs">
                        <p
                          class="d-inline-block d-lg-inline bg-secondary fw-bold px-space-xs py-space-xxs fs-small me-space-md me-lg-0"
                        >
                          {{ $page?.studentsGraduation?.introRank?.title }}
                        </p>
                      </div>

                      <p class="fs-medium">
                        {{ $page?.studentsGraduation?.introRank?.text }}
                      </p>
                    </div>
                  </div>
                  <hr class="d-block d-lg-none col-md-11 col-10 mx-auto" />
                  <div class="col-12 col-lg-4">
                    <div>
                      <!-- stats-->
                      <div
                        class="d-flex flex-column justify-content-start justify-content-lg-center align-items-start align-items-lg-center position-relative mb-space-sm mb-lg-space-md"
                      >
                        <svg viewBox="0 0 38 38" class="svg-circle ms-lg-space-md">
                          <path
                            d="M18 2.0845 a15.9155 15.9155 0 0 1 0 31.831 a15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none"
                            stroke="#d0d0d0"
                            stroke-width="2"
                          />
                          <path
                            d="M18 2.0845 a15.9155 15.9155 0 0 1 0 31.831 a15.9155 15.9155 0 0 1 0 -31.831"
                            :stroke-dasharray="`${$page?.studentsGraduation?.introStat?.title}, 100`"
                            fill="none"
                            stroke="#ffc627"
                            stroke-width="2"
                          />
                        </svg>
                        <div class="circle-text fw-bold">
                          {{ $page?.studentsGraduation?.introStat?.title }}
                        </div>
                        <div
                          class="fs-small text-left text-lg-center ps-lg-space-md"
                          v-html="$page?.studentsGraduation?.introStat?.description"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- section-video -->
      <section class="bg-white py-space-lg py-lg-space-xxl">
        <div class="container">
          <div class="row">
            <div class="col-12" tabindex="0">
              <VideoModalAtlas
                :video-source="videoEmbedUrl"
                :bg-image-source="$page?.studentsGraduation?.video?.imageSource!"
                video-position="right"
                :title="$page?.studentsGraduation?.video?.title!"
                :display-border="false"
                @modal-open="
                  handleModalEvent('open', $page?.studentsGraduation?.video?.title!, 'play button')
                "
                @modal-close="
                  handleModalEvent('close', $page?.studentsGraduation?.video?.title!, 'close cross')
                "
              >
                <div v-html="$page?.studentsGraduation?.video?.description"></div>
              </VideoModalAtlas>
            </div>
          </div>
        </div>
      </section>

      <!-- section-after-college -->
      <section class="px-lg-space-xxs py-lg-space-xxl bg-light-2">
        <div class="container">
          <div class="row">
            <div
              class="col-12 col-lg-10 offset-lg-1 bg-white px-space-xs py-space-lg p-lg-space-xl"
            >
              <h2 class="h2-medium mb-space-sm" tabindex="0">
                {{ $page?.studentsGraduation?.afterCollegeTitle }}
              </h2>
              <div
                class="fs-medium"
                tabindex="0"
                v-html="$page?.studentsGraduation?.afterCollegeDescription"
              ></div>
              <!-- Cards -->
              <div
                v-for="(card, index) in $page?.studentsGraduation?.afterCollegeCards"
                :key="index"
                class="row pt-space-xl"
              >
                <div
                  class="col-12 col-lg-4 px-lg-0"
                  :class="{ 'order-lg-last': orderClass(index) }"
                >
                  <div
                    class="content-img mb-space-md mb-lg-0 rds-lazy"
                    :data-background-image="card?.icon"
                  ></div>
                </div>
                <div class="col-12 col-lg-8 px-lg-0">
                  <div class="p-lg-space-lg" tabindex="0">
                    <h2 class="h2-small mb-space-sm">{{ card?.title }}</h2>
                    <div v-html="card?.description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- section-job-support -->
      <section
        class="px-space-xxs py-space-lg py-lg-space-xxl bg-light-2 rds-lazy"
        :data-background-image="$page?.studentsGraduation?.careerBg"
      >
        <div class="container">
          <div class="row">
            <div
              class="col-12 col-lg-10 offset-lg-1 bg-white px-space-xs py-lg-space-xl px-lg-space-xxl"
            >
              <div class="mb-space-lg" tabindex="0">
                <h2 class="h2-medium mb-space-sm">
                  {{ $page?.studentsGraduation?.careerTitle }}
                </h2>
                <div class="fs-medium" v-html="$page?.studentsGraduation?.careerDescription"></div>
              </div>
              <div
                v-for="(accordion, index) in $page?.studentsGraduation?.careerAccordions"
                :key="index"
                class="mb-space-sm"
              >
                <collapse-item
                  :display-number="false"
                  :collapse-id="generateCollapseId(accordion?.id)"
                  :title="accordion?.title!"
                  :highlight-width="8"
                  class="bg-white"
                  @collapse-shown="
                    handleAccordionClick(
                      'open',
                      $page?.studentsGraduation?.careerTitle!,
                      accordion?.title!
                    )
                  "
                  @collapse-hidden="
                    handleAccordionClick(
                      'close',
                      $page?.studentsGraduation?.careerTitle!,
                      accordion?.title!
                    )
                  "
                >
                  <div v-html="accordion?.description"></div
                ></collapse-item>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- alumni-association section -->
      <section
        class="slide-in-section container py-space-lg py-lg-space-xl"
        aria-labelledby="alumni-section-title"
      >
        <ContentSlideInAtlas
          content-box-class="position-relative py-lg-space-md px-lg-space-sm"
          :image-source="$page?.studentsGraduation?.alumniImage!"
          :image-alt="$page?.studentsGraduation?.alumniImageAlt!"
          background-image-position="center"
          card-position="left"
        >
          <template #card-content>
            <h3 id="alumni-section-title" class="h3-xl text-dark-3 mb-space-sm" tabindex="0">
              {{ $page?.studentsGraduation?.alumniTitle }}
            </h3>
            <div
              class="fs-large text-dark-3 mb-space-xs"
              tabindex="0"
              v-html="$page?.studentsGraduation?.alumniDescription"
            ></div>
            <div class="d-flex">
              <a
                :href="$page?.studentsGraduation?.alumniLink?.uri!"
                :target="getCtaTarget($page?.studentsGraduation?.alumniLink?.target!)"
                class="rds-link fs-small fw-bold"
                @click="handleCtaClick($page?.studentsGraduation?.alumniTitle!)"
                >{{ $page?.studentsGraduation?.alumniLink?.text }}</a
              >
            </div>
          </template>
        </ContentSlideInAtlas>
      </section>

      <!-- explore-your-future section -->
      <SectionExploreYourFuture
        :title="$page?.studentsGraduation?.exploreTitle!"
        :items="$page?.studentsGraduation?.exploreCards! as ExploreItem[]"
      />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import type { ExploreItem } from "~/components/students/SectionExploreYourFuture.vue";
import SectionExploreYourFuture from "~/components/students/SectionExploreYourFuture.vue";
import { useUtilityService } from "~/composables/useUtilityService";
import type { StudentsGraduation } from "~/server/resolvers/resolvers-types";
import type { StudentsGraduationQuery } from "~/types/graphql-operations";

definePageMeta({
  layout: false,
  __dangerouslyDisableSanitizersByTagID: {
    "ldjson-schema": ["innerHTML"]
  }
});

const config = useRuntimeConfig();

const UtilityService = useUtilityService();

const $page = await usePageQuery<StudentsGraduationQuery>(
  /* GraphQL */ `
    #graphql
    query studentsGraduation($studentsGraduationId: ID!) {
      studentsGraduation(id: $studentsGraduationId) {
        detailPage
        metaTitle
        metaDescription
        heroImage
        title
        introTitle
        introBg
        introDescription
        introRank {
          title
          text
        }
        introStat {
          title
          description
        }
        video {
          title
          imageSource
          description
          youtubeId
          uploadDate
          duration
        }
        afterCollegeTitle
        afterCollegeDescription
        afterCollegeCards {
          title
          description
          icon
        }
        careerTitle
        careerBg
        careerDescription
        careerAccordions {
          id
          title
          description
        }
        alumniTitle
        alumniImage
        alumniImageAlt
        alumniDescription
        alumniLink {
          text
          uri
          target
        }
        exploreTitle
        exploreBg
        exploreCards {
          title
          image
          link {
            text
            uri
            target
          }
        }
      }
    }
  `,
  {
    studentsGraduationId: "a2d47466-dee9-4b01-b55f-bd82f63cd4f3"
  },
  {
    key: "students-graduation"
  }
);

useHead({
  title: $page?.studentsGraduation?.metaTitle,
  meta: [
    { name: "Title", content: $page?.studentsGraduation?.metaTitle },
    {
      name: "Description",
      content: $page?.studentsGraduation?.metaDescription
    }
  ],
  link: [
    {
      rel: "canonical",
      href: UtilityService.formatCanonicalUrl(
        `${config.public.siteUrl}${$page?.studentsGraduation?.detailPage}`
      )
    }
  ],
  script: [
    useSchemaService().generateStudentsGraduationSchema(
      $page?.studentsGraduation as unknown as StudentsGraduation
    )
  ]
});

const videoEmbedUrl = computed(() => {
  return `https://www.youtube.com/embed/${$page?.studentsGraduation?.video?.youtubeId}`;
});

const handleModalEvent = (action: string, section: string, text: string) => {
  analyticsComposable.trackModalEvent(
    "onclick",
    action.toLowerCase(),
    "click",
    "main content",
    section.toLowerCase(),
    text.toLowerCase()
  );
};

const orderClass = (index: number) => {
  return index % 2 !== 0;
};

const generateCollapseId = (id: string | undefined) => {
  if (id) {
    return `career-${id}`;
  } else {
    console.error("collapse id missing");
    return `career-placeholder`;
  }
};

const handleCtaClick = (title: string) => {
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    title.toLowerCase(),
    $page?.studentsGraduation?.alumniLink?.text?.toLowerCase() ?? ""
  );
};

const handleAccordionClick = (action: string, section: string, text: string) => {
  analyticsComposable.trackCollapseEvent(
    "onclick",
    action.toLowerCase(),
    "click",
    "main content",
    section.toLowerCase(),
    text.toLowerCase()
  );
};

const getCtaTarget = (target: string) => {
  return target === "SELF" ? "_self" : "_blank";
};
</script>

<style lang="scss" scoped>
.title-underline {
  width: 64px;
  height: 10px;
}

.bg-pattern {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.svg-circle {
  height: 136px;
  width: 136px;
}

.circle-text {
  position: absolute;
  top: 12%;
  left: 20px;
  font-size: 36px;
}

.slide-in-section :deep(.rds-slidein-atlas-container .slide-in-left) {
  animation-delay: 100ms;
  animation-fill-mode: both;
}

.slide-in-section :deep(.rds-slidein-atlas-container .scale-back) {
  animation-delay: 50ms;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
}

.content-img {
  height: 280px;
  width: 280px;
  background-position: 50%;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  margin: auto;
}

/* Larger devices (tablets => 768px and up, desktops => 992px and up) */
@media (width >= 768px) {
  .circle-text {
    top: 15%;
  }
}

@media (width >= 992px) {
  .circle-text {
    top: 11%;
    left: calc((100% - 32px) / 2 + 22px);
    transform: translateX(-50%);
  }

  .border-intro {
    border-right: 1px solid var(--rds-light-4, #d0d0d0);
  }
}
</style>
